import cookie from 'react-cookie';
const LANGUAGE_COOKIE = 'LANGUAGE_COOKIE';
export function getLanguageCookie() {
    return cookie.load(LANGUAGE_COOKIE);
}

export function saveLanguageCookie(languageCode) {
    cookie.save(LANGUAGE_COOKIE, languageCode, {
        path: '/'
    });
}

export function isEnglish() {
    return getLanguageCookie() === 'en';
}



// WEBPACK FOOTER //
// ./src/js/localization/language-cookie.js